const firebaseConfig = {
  apiKey: "AIzaSyB6tzPvnmsFFu4lz_do9m6a8YCtAUxG5AA",
  authDomain: "nobero-d2c.firebaseapp.com",
  projectId: "nobero-d2c",
  storageBucket: "nobero-d2c.firebasestorage.app",
  messagingSenderId: "994482143466",
  appId: "1:994482143466:web:9527cd6e70e6aa9cf5d793",
  measurementId: "G-RTQWEXR01Z"
};

firebase.initializeApp(firebaseConfig);

const analytics = firebase.analytics();
analytics.setAnalyticsCollectionEnabled(true);
const remoteConfig = firebase.remoteConfig();

remoteConfig.settings = {
  minimumFetchIntervalMillis: 0
};

remoteConfig.fetchAndActivate().then(() => { 
    const ab_variant = remoteConfig.getString("dummy_experiment");
    let gaExpObj = {
        event: 'experiment_viewed',
        experiments: JSON.stringify({
            name: 'dummy_experiment',
            variant: ab_variant,
            variant_name: ab_variant,
        }),
    };
    dataLayer.push(gaExpObj);
    console.log("Variant:", ab_variant);
});
